import React from 'react';
import styled from 'styled-components';
import { Container, Row, Col } from 'react-bootstrap';
import { Linkedin } from 'react-bootstrap-icons';
import LinkComponent from '../../utils/linkComponent';
import { openJoinModal } from '../../utils/buttonHandlers';
import storyIcon from '../../images/story.png';
import contactIcon from '../../images/contact.png';
import memberIcon from '../../images/member.png';
import linkedinIcon from '../../images/linkedin.png';
import linkedinGroupIcon from '../../images/linkedin-group.png';

const GetInvolvedStyled = styled.div`
	background: var(--secondary_4); /* Use secondary_4 color as background */
	padding: 3rem 3rem;
	margin: 0;
	color: #333;
	text-align: center;

	.get-involved-title {
		font-size: 2.5rem;
		font-weight: 700;
		margin-bottom: 2rem;
		color: var(--primary);
		font-family: var(--primary_font_family);
		text-align: center;
	}

	.column-container {
		margin-top: 2rem;
	}

	.column {
		padding: 1rem;
		text-align: center;
	}

	.column-icon {
		font-size: 2.5rem;
		color: var(--secondary_1);
		margin-bottom: 1rem;
		display: block;
		text-align: center;
		width: 4rem;
		height: 4rem;
		margin-left: auto;
		margin-right: auto;
	}

	.column-icon img {
		max-width: 4rem;
		max-height: 4rem;
		width: auto;
		height: auto;
		object-fit: contain;
	}

	/* Increase width specifically for the contact us icon */
	.contact-icon {
		max-width: 6rem !important;
		max-height: none !important;
		width: auto !important;
		height: auto !important;
	}

	.column-heading {
		font-size: var(--font-size-md);
		font-weight: 700;
		color: var(--secondary_1);
		margin-bottom: 1rem;
		font-family: var(--primary_font_family);
		line-height: 1.3;
	}

	.column-text {
		font-size: var(--font-size-base);
		color: #666;
		font-family: var(--primary_font_family);
		line-height: 1.5;
		text-align: center;
	}

	.column-link {
		color: var(--secondary_1);
		text-decoration: none;
		font-weight: 600;
	}

	.column-link:hover {
		color: var(--primary);
		text-decoration: none;
	}

	@media (max-width: 768px) {
		padding: 2rem 1rem;

		.get-involved-title {
			font-size: 2rem;
		}

		.column {
			margin-bottom: 2rem;
			text-align: center;
		}

		.column-heading {
			font-size: 1.2rem;
		}

		.column-text {
			font-size: 0.95rem;
		}
	}
`;

const GetInvolved = () => {
	return (
		<GetInvolvedStyled>
			<Container>
				<h2 className='get-involved-title'>Get involved</h2>
				<Row className='column-container'>
					<Col xs={12} sm={6} md={3}>
						<a
							href='https://www.linkedin.com/groups/4397742/'
							target='_blank'
							rel='noopener noreferrer'
							className='column-link'
							style={{ textDecoration: 'none', display: 'block' }}
						>
							<div className='column'>
								<img
									src={linkedinGroupIcon}
									alt='LinkedIn icon'
									className='column-icon'
								/>
								<h3 className='column-heading'>Join the LinkedIn Group</h3>
								<p className='column-text'>
									Connect with WIL professionals and share best practices.
								</p>
							</div>
						</a>
					</Col>
					<Col xs={12} sm={6} md={3}>
						<a
							href='https://www.linkedin.com/company/wil-australia/'
							target='_blank'
							rel='noopener noreferrer'
							className='column-link'
							style={{ textDecoration: 'none', display: 'block' }}
						>
							<div className='column'>
								<img
									src={linkedinIcon}
									alt='LinkedIn icon'
									className='column-icon'
								/>
								<h3 className='column-heading'>Follow the LinkedIn Page</h3>
								<p className='column-text'>
									Stay updated with our latest news, events, and WIL insights.
								</p>
							</div>
						</a>
					</Col>
					<Col xs={12} sm={6} md={3}>
						<div
							className='column column-link'
							style={{ cursor: 'pointer' }}
							onClick={() => openJoinModal()}
						>
							<img src={memberIcon} alt='Member icon' className='column-icon' />
							<h3 className='column-heading'>Become a Member</h3>
							<p className='column-text'>
								Become part of Australia's national Work-Integrated Learning
								(WIL) community. Join WIL Australia to access grants, share
								practice, grow your network, and shape the future of WIL.
							</p>
						</div>
					</Col>
					{/* <Col xs={12} sm={6} md={3}>
						<div className='column'>
							<img src={storyIcon} alt='Story icon' className='column-icon' />
							<h3 className='column-heading'>Contribute a Story / Article</h3>
							<p className='column-text'>
								Have a story to tell? Your experiences as an educator, employer,
								or student helps inspire others and showcase real-world impact.
							</p>
						</div>
					</Col> */}
					<Col xs={12} sm={6} md={3}>
						<a
							href='/contact-us'
							className='column-link'
							style={{ textDecoration: 'none', display: 'block' }}
						>
							<div className='column'>
								<img
									src={contactIcon}
									alt='Contact icon'
									className='column-icon contact-icon'
								/>
								<h3 className='column-heading'>Contact Us</h3>
								<p className='column-text'>
									We're here to help you connect, contribute, or answer your
									questions.
								</p>
							</div>
						</a>
					</Col>
				</Row>
			</Container>
		</GetInvolvedStyled>
	);
};

export default GetInvolved;
